import { render } from "./SelectLiveToVodModal.vue?vue&type=template&id=ed0ac8ee&scoped=true"
import script from "./SelectLiveToVodModal.vue?vue&type=script&lang=js"
export * from "./SelectLiveToVodModal.vue?vue&type=script&lang=js"

import "./SelectLiveToVodModal.vue?vue&type=style&index=0&id=ed0ac8ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0ac8ee"]])

export default __exports__